import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const formattedMsg = msg => {
    const newText = msg.replace(/(@[^:\s]+)/g, username => {
        return `<span class='slack-message__user'>${username}</span>`;
    });

    return { __html: newText };
};

const AppDialogueBox = props => {
    const {
        isPinned,
        date,
        bodyText,
        actionBtn,
        cancelBtn,
        bodyHasBorder,
        hasShadow,
        className
    } = props;

    const classes = classNames("app-dialogue-box", className, {
        "app-dialogue-box--has-shadow": hasShadow
    });

    const bodyClasses = classNames("app-dialogue-box__body", className, {
        "app-dialogue-box__body--with-border": bodyHasBorder
    });

    return (
        <div className={classes}>
            {date && (
                <div className="app-dialogue-box__date">
                    <p>{date}</p>
                </div>
            )}
            {isPinned && (
                <div className="app-dialogue-box__pinned">
                    <p>Pinned to Chat</p>
                </div>
            )}
            <div className="app-dialogue-box__header">
                <div className="app-dialogue-box__header-avatar">
                    <img
                        src={require(`../../imgs/avatar-bot-dialogue.png`)}
                        alt="3 Things Balloon"
                    />
                </div>
                <span className="app-dialogue-box__header-name">3things</span>
                <span className="app-dialogue-box__header-app">APP</span>
            </div>
            <div className={bodyClasses}>
                <p dangerouslySetInnerHTML={formattedMsg(bodyText)} />
                {actionBtn && (
                    <div className="app-dialogue-box__btns">
                        <span className="app-dialogue-box__btn app-dialogue-box__btn---action">
                            {actionBtn}
                        </span>
                        {cancelBtn && (
                            <span className="app-dialogue-box__btn app-dialogue-box__btn--cancel">
                                {cancelBtn}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

AppDialogueBox.propTypes = {
    className: PropTypes.string,
    actionBtn: PropTypes.string,
    bodyHasBorder: PropTypes.bool,
    bodyText: PropTypes.string.isRequired,
    cancelBtn: PropTypes.string,
    date: PropTypes.string,
    hasShadow: PropTypes.bool,
    isPinned: PropTypes.bool
};

export default AppDialogueBox;



// WEBPACK FOOTER //
// ./src/components/landingPage/AppDialogueBox.jsx